<script>
    export let lead;
    export let text;
</script>

<div class="columns">
    <div class="column is-3"><strong>{lead}:</strong></div>
    <div class="column has-text-centered-mobile">{text}</div>
</div>